import Button from "Components/button/button";
import ProgressOverlay from "Components/progressOverlay";
import WelcomePanel from "Components/welcomePanel";
import classNames from "classnames";
import keys from "lodash/keys";
import React, { memo, useCallback, useEffect, useMemo } from "react";
import { sendToGraphButtonAttrs, sendToGraphSelector } from "../content/constants";
import RowActionsPanel from "../content/rowActionsPanel";
import addSendToGraphListener from "../content/switcherFeed/utils/listeners/addSendToGraphListener";
import { folderBlockIdPrefix } from "./constants";
import locale from "./contentUpload.locale";
import Folder from "./folder";
import FolderEditorPanel from "./folderEditorPanel";
function ContentUpload(props) {
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    useEffect(() => {
        const sendToGraphElement = sendToGraphSelector
            ? document.querySelector(sendToGraphSelector)
            : undefined;
        return addSendToGraphListener(sendToGraphElement, folderBlockIdPrefix, undefined, undefined, props.documentId, props.documentObjects, props.onTextSendToGraph);
    }, [props.documentId, props.documentObjects, props.onTextSendToGraph]);
    useEffect(() => {
        !props.folders &&
            props.documentId &&
            props.onGetFolders &&
            props.onGetFolders(props.documentId);
    }, [props.documentId, props.onGetFolders]);
    const folder = useMemo(() => props.folders && props.selectedFolderId && props.folders[props.selectedFolderId], [props.folders, props.selectedFolderId]);
    const hasFolders = useMemo(() => keys(props.folders).length > 0, [props.folders]);
    const handleCreateFolder = useCallback(() => props.onOpenFolderCreatorPanel &&
        props.documentId &&
        props.onOpenFolderCreatorPanel(props.documentId), [props.onOpenFolderCreatorPanel, props.documentId]);
    useEffect(() => {
        props.onInProgressChanged && props.onInProgressChanged(Boolean(props.inProgress));
    }, [props.inProgress]);
    return (React.createElement(ProgressOverlay, { show: props.inProgress, className: classNames("overflow-hidden", props.className) },
        React.createElement("div", null,
            React.createElement(RowActionsPanel, { rowActionsPanelHeight: props.rowActionsPanelHeight, sendToGraphButtonAttrs: sendToGraphButtonAttrs, sendToGraphSelector: sendToGraphSelector }),
            React.createElement(FolderEditorPanel, { folders: props.folders, documentId: props.documentId }),
            React.createElement("div", { className: "grid-rows-auto-1fr h-100" },
                React.createElement("div", { className: "position-relative overflow-hidden", style: { gridRow: 2 } },
                    React.createElement("div", { className: "stretched-to-fit h-100-max overflow-hidden" }, folder ? (React.createElement(Folder, { folder: folder, files: props.files, onSaveFolder: props.onSaveFolder, documentId: props.documentId, documentObjects: props.documentObjects, blockIdPrefix: folderBlockIdPrefix, onPhotoSendToGraph: props.onPhotoSendToGraph, onTextSendToGraph: props.onTextSendToGraph, bottomOffset: props.bottomOffset })) : (props.folders && (React.createElement("div", { className: "flex-box-centered-content h-100" },
                        React.createElement(WelcomePanel, { messageClassName: "font-base", showIcon: false, message: hasFolders ? locale.NOT_SELECTED_TEXT : locale.NO_DATA_TEXT },
                            React.createElement(Button, { className: "mt-1 btn-primary", text: locale.ADD_FOLDER, icon: "plus", onClick: handleCreateFolder })))))))))));
}
export default memo(ContentUpload);
